import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import SolicitacaoNaoAtendidaFornecedorStore from "../stores/SolicitacaoNaoAtendidaFornecedorStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";
import {Row, Col} from 'reactstrap';
import {CustomBarChart} from "../../comum/components/CustomBarChart";

const FILTROS = ["COMPETENCIA"];

@inject("store")
@DataWrapper
@observer
export class SolicitacaoNaoAtendidaFornecedor extends Component {
    constructor(props) {
        super(props);
        this.controller = new SolicitacaoNaoAtendidaFornecedorStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Solicitações não atendidas por fornecedor (ETT)");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <MensagemErro>
                        {this.controller.erro}
                    </MensagemErro>
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                history={this.props.history}
                                controller={this.controller}
                                location={this.props.location}
                                fields={FILTROS} />
                        <Row>
                            <Col xs={12} md={12} lg={10}>
                                <CustomBarChart stackId="1" dataKeys={this.controller.razoes} data={this.controller.dados}
                                        labelAxisX={"Fornecedor"} labelAxisY={"Quantidade"} />
                            </Col>
                        </Row>
                    </LoadingBlockFields>
                </div>
            </div>
        )
    }
}
